<template>
  <div class="">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LoginLayout'
}
</script>



// WEBPACK FOOTER //
// src/layouts/login-layout/LoginLayout.vue